import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { AssistantQuestionsContent } from '@/pageContents/kiEinstellungen/AssistantQuestionsContent';
import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Permission } from '@/models/user';

const AssistantQuestions: PageWithLayout = () => (
    <>
        <Helmet>
            <title>Vorgeschlagene Fragen | Starjack Backoffice</title>
        </Helmet>
        <Box sx={{ p: 3 }}>
            <AssistantQuestionsContent />
        </Box>
    </>
);

AssistantQuestions.isProtected = true;
AssistantQuestions.getLayout = (Comp) => <SidebarLayout>{Comp}</SidebarLayout>;
AssistantQuestions.permissions = [Permission.ADMIN];

export default AssistantQuestions;
